import { faLightbulb } from '@fortawesome/pro-solid-svg-icons';

import { useTranslate } from '@growtherapy/i18n';
import { Icon, Tag, Text } from '@growtherapy/sprout-ui';

import { Toast } from '../../../toasts/Toast';
import { ToastRenderFnProps } from '../../../toasts/types';
import type { SessionRecapBannerVariant } from '../usePatientSessionRecapAccess';

export function LeaveSessionNudgeToast({
  contentProps,
  descriptionProps,
  titleProps,
  variant = 'legacy',
  ...toastAriaProps
}: ToastRenderFnProps & { variant?: SessionRecapBannerVariant }) {
  const t = useTranslate();

  if (variant === 'recap' || variant === 'noRecap') {
    const body =
      variant === 'recap'
        ? t('telehealth-core:controls.whenYourSessionIsOverReviewKeyMomentsInRecap')
        : t('telehealth-core:controls.afterTheSessionWellGuideYouThroughNextSteps');

    return (
      <Toast alignment='top' className='sm:w-[30rem]' {...toastAriaProps}>
        <div className='flex flex-col gap-1' {...contentProps}>
          <Text variant='sm' className='font-semibold' {...titleProps}>
            {t('telehealth-core:controls.sessionEndsSoon')}
          </Text>
          <Text variant='sm' {...descriptionProps}>
            {body}
          </Text>
        </div>
      </Toast>
    );
  }

  return (
    <Toast alignment='top' className='sm:w-[30rem]' {...toastAriaProps}>
      <div className='flex gap-4 align-start flex-col' {...contentProps}>
        <div className='flex justify-between'>
          <Tag
            aria-label={t('telehealth-core:controls.theCurrentAppointmentWillBeEndingSoon')}
            use='green'
            // `Tag` ships a `rebrand:gap-x-50` (2px) default, and an Arc root carries both the
            // `rebrand` and `arc` classes, so that 2px applies here too. `arc:` wins it back:
            // same specificity, but the theme plugin emits brand variants in precedence order.
            className='flex flex-row justify-start items-center gap-2 arc:gap-x-125 px-2 py-1'
          >
            <Icon aria-hidden icon={faLightbulb} className='arc:text-text-inverse' />
            <Text variant='xs' className='arc:text-text-inverse' {...titleProps}>
              {t('telehealth-core:controls.growTip')}
            </Text>
          </Tag>
        </div>
        <Text variant='sm' {...descriptionProps}>
          {t('telehealth-core:controls.nearingTheEndUseTheLeaveSessionButton')}
        </Text>
      </div>
    </Toast>
  );
}
